import React, { Fragment, useCallback, useRef, useState } from 'react';

import useOutsideClick from '../../../hooks/useOutsideClick';

import Label from '../label';

import { Menu, MenuItem, StyledTabButton, StyledTabButtonContainer } from './dropdownButton.style';
import { ChevronDownBlack } from '../../icons';
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline';
import { IntlMessages } from '../../../helper/langHelper';

const DropdownButton = (props) => {
  const {
    buttonArray,
    onClick = () => {},
    buttonText = <IntlMessages id="button.text.download.options" />,
    dropDownWidth = '233px',
  } = props;
  const [isOpened, setOpened] = useState(false);
  const node = useRef(null);

  const handleClickItem = useCallback(
    ({ item }) => {
      if (onClick) onClick(item);
      setOpened(false);
    },
    [onClick]
  );

  useOutsideClick({
    isOpen: isOpened,
    node,
    onOutsideClick: () => setOpened(false),
  });
  console.log(isOpened);
  const renderMenu = (data, dropDownWidth) => {
    return (
      <Menu
        className="filterDropdown-menu-items hide-scroll-bar"
        isOpened={isOpened}
        dropDownWidth={dropDownWidth}
      >
        {data &&
          data.map((item, index) => {
            return (
              <Fragment key={index}>
                <MenuItem key={item.key} onClick={() => handleClickItem({ item })}>
                  <span style={{ color: '#fff' }}>{item.icon}</span>
                  <Label cursor="pointer">{item.title}</Label>
                </MenuItem>
              </Fragment>
            );
          })}
      </Menu>
    );
  };
  const handleClickedTabButton = () => {
    setOpened(!isOpened);
  };

  return (
    <StyledTabButtonContainer ref={node}>
      <StyledTabButton textTransform="capitalize" onClick={handleClickedTabButton}>
        <DownloadForOfflineIcon />
        <Label align="center" cursor="pointer" color="light">
          {buttonText}
        </Label>
        <Fragment>{buttonArray && <ChevronDownBlack />}</Fragment>
      </StyledTabButton>
      {isOpened && renderMenu(buttonArray, dropDownWidth)}
    </StyledTabButtonContainer>
  );
};

export default DropdownButton;
